<template>
  <div class="qc-card shadow mx-auto">
    <div class="qc-logo text-center">
      <img class="img-fluid" :src="logoUrl" alt="logo" />
    </div>
    <h4 class="text-center pb-4 ">會員註冊</h4>
    <div class="step-group d-flex justify-content-center">
      <span
        class="step"
        data-text="資料填寫"
        :class="{ active: step, previous: !step }"
        >1</span
      >
      <span class="step-line" :class="{ active: !step }"></span>
      <span class="step" data-text="手機驗證" :class="{ active: !step }"
        >2</span
      >
    </div>
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <div v-if="step">
        <b-form-group
          label="姓名"
          label-for="name"
          invalid-feedback="請填寫姓名"
          :state="state.name"
          class="required"
        >
          <b-form-input
            id="name"
            class="rounded-0"
            v-model="form.name"
            type="text"
            required
            placeholder="姓名"
            :state="state.name"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="公司名稱"
          label-for="company_name"
          invalid-feedback="請填寫公司名稱"
          :state="state.company_name"
          class="required"
        >
          <b-form-input
            id="company_name"
            class="rounded-0"
            v-model="form.company_name"
            type="text"
            required
            placeholder="公司名稱"
            :state="state.company_name"
          ></b-form-input>
        </b-form-group>
        <TWCityTown
          @childMethod="getTWCityTown"
          :state="state.address"
          :group_class="'required'"
        ></TWCityTown>
        <b-form-group
          label="負責人"
          label-for="principal"
          invalid-feedback="請填寫公司負責人"
          :state="state.principal"
          class="required"
        >
          <b-form-input
            id="principal"
            class="rounded-0"
            v-model="form.principal"
            type="text"
            required
            placeholder="公司負責人"
            :state="state.principal"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="統一編號"
          label-for="tax_id"
        >
          <b-form-input
            id="tax_id"
            class="rounded-0"
            v-model="form.tax_id"
            type="text"
            placeholder="統一編號"
          ></b-form-input>
        </b-form-group>
      </div>
      <div v-else>
        <b-form-group label="手機號碼" label-for="telephone" class="required">
          <b-input-group>
            <b-form-input
              id="telephone"
              class="rounded-0"
              type="tel"
              v-model="form.telephone"
              :state="verification_tel"
              required
              placeholder="請輸入手機號碼"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                block
                squared
                variant="platform_sub"
                class="text-white"
                :disabled="sendBtnIsDisabled"
                @click="sendCountdownTime"
                >{{
                  verification_tel
                    ? "重新傳送驗證碼 " +
                      (sendBtnIsDisabled && minutes_to_send != 0
                        ? minutes_to_send + " 分"
                        : "") +
                      (sendBtnIsDisabled && seconds_to_send != 0
                        ? " " + seconds_to_send + " 秒"
                        : "")
                    : "傳送驗證碼"
                }}
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback :state="verification_tel">
              請輸入正確的手機號碼
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <div
          class="text-center text-danger mb-4"
          style="font-size: 14px;"
          v-if="authError"
        >
          {{ authText }}
          <br />
          {{
            authText == "403 Too March Request"
              ? "嘗試次數過多，請等候30秒再重新傳送驗證碼"
              : "請檢查是否填寫正確，再重新輸入一次"
          }}
        </div>
        <div
          class="text-center text-danger mb-4"
          style="font-size: 14px;"
          v-if="verification_tel && sendBtnIsDisabled"
        >
          驗證碼將以簡訊方式傳送到您的手機 <br />
          請注意查收 ({{ effective_time }}內有效)
        </div>
        <b-form-group
          label="請輸入驗證碼"
          label-for="authCode"
          class="required"
        >
          <b-form-input
            id="authCode"
            class="rounded-0"
            type="text"
            v-model="form.authCode"
            :state="verification_code"
            :required="verification_tel"
            placeholder="請輸入驗證碼"
          ></b-form-input>
          <b-form-invalid-feedback :state="verification_code">
            {{ verification_text }}
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <b-button block squared variant="platform_main" type="submit">{{
        step ? "下一步" : "註冊"
      }}</b-button>
      <b-button
        block
        squared
        variant="platform_sub"
        type="button"
        v-if="!step"
        @click="step++"
        >上一步</b-button
      >
      <div class="text-right mt-3">
        已是會員了嗎？
        <b-link href="/login" class="text-platform_main">立即登入</b-link>
      </div>
    </b-form>
    <vue-recaptcha
      ref="recaptcha"
      :sitekey="sitekey"
      @verify="onCaptchaVerified"
      @expired="onCaptchaExpired"
      size="invisible"
      badge="bottomright"
      :loadRecaptchaScript="true"
    ></vue-recaptcha>
  </div>
</template>

<style lang="scss" scoped>
.qc {
  &-card {
    width: 90%;
    padding: 30px;
    background-color: #fff;
  }
}
.step-group {
  padding-bottom: 30px;
  .step {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    color: #fff;
    position: relative;
    text-align: center;
    z-index: 1;
    &::before {
      content: attr(data-text);
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 200%;
      transform: translate(-50%, 100%);
      color: #333;
      font-size: 12px;
      line-height: 2;
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #aaa;
      border-radius: 40px;
      z-index: -1;
    }
    &.active {
      &::after {
        background-color: $platform_main;
      }
    }
    &.previous {
      opacity: 0.5;
      &::after {
        background-color: $platform_main;
      }
    }
  }
  .step-line {
    max-width: 100px;
    width: 100%;
    margin: 18px 0;
    height: 4px;
    background-color: #aaa;
    &.active {
      background: linear-gradient(
        90deg,
        rgba($platform_main, 0.5),
        $platform_main
      );
    }
  }
}
</style>

<script>
import { registerPlatform } from "@/assets/api/platform.js";
import TWCityTown from "@/components/TWCityTown.vue";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "Register",
  props: ["identity"],
  components: { TWCityTown, VueRecaptcha },
  data() {
    return {
      step: 1,
      form: {
        name: "",
        telephone: "",
        authID: "",
        authCode: "",
        company_name: "",
        town_id: "",
        address: "",
        principal: "",
        tax_id: "",
        city_id: "",
        google_recaptcha_token: null
      },
      state: {
        name: null,
        company_name: null,
        address: null,
        principal: null
      },
      sitekey: "6LfiSZUaAAAAANjYYoB3Im-U8qvQQX-ad39h8cea",
      verification_tel: null,
      verification_code: null,
      verification_text: null,
      sendBtnIsDisabled: false,
      seconds_to_send: 0,
      minutes_to_send: 0,
      effective_time: "",
      authError: false,
      authText: ""
    };
  },
  created() {
    this.verification_code = null;
    this.effective_time = Number(process.env.VUE_APP_MINUTES_TO_SEND_SMS || 0)
      ? process.env.VUE_APP_MINUTES_TO_SEND_SMS + " 分鐘"
      : "";
    this.effective_time += Number(process.env.VUE_APP_SECONDS_TO_SEND_SMS || 30)
      ? (process.env.VUE_APP_SECONDS_TO_SEND_SMS || 30) + " 秒"
      : "";
    this.seconds_to_send = Number(
      process.env.VUE_APP_SECONDS_TO_SEND_SMS || 30
    );
    this.minutes_to_send = Number(process.env.VUE_APP_MINUTES_TO_SEND_SMS || 0);
  },
  computed: {
    logoUrl() {
      if (this.identity == "manage") {
        return require("@/assets/image/quartercar-logo.svg");
      } else {
        return require("@/assets/image/quartercar-logo_red.svg");
      }
    }
  },
  watch: {
    "form.telephone": function(val) {
      if (val) {
        this.verification_tel = null;
        this.verification_code = null;
        this.verification_text = null;
      }
    }
  },
  methods: {
    sendCountdownTime() {
      let data = {};
      if (!process.env.NODE_ENV === "development") {
        this.$refs.recaptcha.reset();
      } else {
        this.form.google_recaptcha_token = "test";
      }
      data = {
        telephone: this.form.telephone,
        google_recaptcha_token: this.form.google_recaptcha_token
      };
      if (
        this.form.telephone == "" ||
        !/^09[0-9]{8}$/.test(this.form.telephone)
      ) {
        this.verification_tel = false;
        return;
      }
      this.verification_tel = null;
      this.verification_code = null;
      this.verification_text = null;
      this.authError = false;

      registerPlatform
        .register(data)
        .then(res => {
          if (res.status <= 201) {
            this.form.authCode = res.data.authCode;

            this.form.authID = res.data.authID;
            this.verification_tel = true;
            this.sendBtnIsDisabled = true;
            this.seconds_to_send = Number(
              process.env.VUE_APP_SECONDS_TO_SEND_SMS || 30
            );
            this.minutes_to_send = Number(
              process.env.VUE_APP_MINUTES_TO_SEND_SMS || 0
            );
            let countdown = setInterval(() => {
              if (this.seconds_to_send == 1 && this.minutes_to_send == 0) {
                clearTimeout(countdown);
                this.sendBtnIsDisabled = false;
              } else if (this.seconds_to_send == 0) {
                this.minutes_to_send -= 1;
                this.seconds_to_send = 60;
              }
              this.seconds_to_send -= 1;
            }, 1000);
          } else {
            this.authError = true;
            this.authText = res.status + " ";
            this.authText += res.data.error;
          }
        })
        .catch(err => {
          this.authError = true;
          this.authText = err;
        });
    },
    getTWCityTown(data) {
      this.form.city_id = data.city_id;
      this.form.town_id = data.town_id;
      this.form.address = data.complete_address;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.checkFormState();
      return valid;
    },
    checkFormState() {
      if (this.step) {
        this.form.name ? (this.state.name = null) : (this.state.name = false);
        this.form.company_name
          ? (this.state.company_name = null)
          : (this.state.company_name = false);
        this.form.address
          ? (this.state.address = null)
          : (this.state.address = false);
        this.form.principal
          ? (this.state.principal = null)
          : (this.state.principal = false);
      }
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      for (const [key, value] of Object.entries(this.state)) {
        if (value === false) {
          console.log(key);
          return;
        }
      }
      if (this.step) {
        this.step--;
      } else {
        registerPlatform
          .confirm(this.form)
          .then(res => {
            if (res.status <= 201) {
              localStorage.setItem("platform-api_token", res.data.api_token);
              this.$router.push({ name: "首頁" });
            } else {
              this.verification_code = false;
              this.verification_text = res.data.error;
            }
          })
          .catch(err => {
            this.verification_code = false;
            this.verification_text = err;
          });
      }
    },
    onCaptchaVerified(token) {
      this.form.google_recaptcha_token = token;
      this.sendCountdownTime();
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    }
  }
};
</script>
